import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCodeAssistant: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="code-assistant, vibe-coding"><path d="M13 3.75H3.75V20.25H20.25V11" stroke="currentColor" strokeWidth="1.5"/><path d="M10.75 9L7.75 12L10.75 15" stroke="currentColor" strokeWidth="1.5"/><path d="M13.25 9L16.25 12L13.25 15" stroke="currentColor" strokeWidth="1.5"/><path d="M19 1L20.0804 3.91964L23 5L20.0804 6.08036L19 9L17.9196 6.08036L15 5L17.9196 3.91964L19 1Z" fill="currentColor"/></CentralIconBase>;
};

export default IconCodeAssistant;
